import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    loadMore: 'Load more',
    noRequestsDescription:
      'Here you will find your current refund requests, to be validated by the account holder.',
    noRequestsTitle: 'No claim requests',
    requestExpenseClaim: 'Request a refund',
    title: 'Expense claims',
  },
  fr: {
    loadMore: 'Charger plus',
    noRequestsDescription:
      'Retrouvez ici vos demandes de remboursement, à valider par le ou la titulaire du compte.',
    noRequestsTitle: 'Aucune note de frais',
    requestExpenseClaim: 'Demander un remboursement',
    title: 'Notes de frais',
  },
} as const);

export default locales;
